import filterAPI from "../api/filterAPI";
import { ActionTypesScreen5 } from "app/constants";

export function updateOccupationTypeScreen5(occupationType) {
  return {
    type: ActionTypesScreen5.UPDATE_OCCUPATION_TYPE_SCREEN5,
    payload: occupationType,
  };
}

export function fetchOccupationData() {
  return (dispatch) => {
    filterAPI
      .getAllOccupationNamesScreen5()
      .then((res) => {
        let occupationData = res.data.data;
        dispatch(handleOccupationData(occupationData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleOccupationData(data) {
  return {
    type: ActionTypesScreen5.GET_OCCUPATION_DATA_SCREEN5,
    payload: data,
  };
}

export function fetchAverageDataScreen5(
  region_name,
  naics_dropdown_value,
  jobtype_dropdown_value,
  occupation_dropdown_value
) {
  return (dispatch) => {
    filterAPI
      .getAverageDetailsScreen5({
        region_name: region_name,
        naics_dropdown_value: naics_dropdown_value,
        jobtype_dropdown_value: jobtype_dropdown_value,
        occupation_dropdown_value: occupation_dropdown_value,
      })
      .then((res) => {
        let averageDataScreen5 = res.data.data;
        dispatch(handleAverageDataScreen5(averageDataScreen5));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleAverageDataScreen5(data) {
  return {
    type: ActionTypesScreen5.GET_AVERAGE_DATA_SCREEN5,
    payload: data,
  };
}

export function fetchIncomeDataScreen5(
  region_name,
  naics_dropdown_value,
  jobtype_dropdown_value,
  occupation_dropdown_value
) {
  return (dispatch) => {
    filterAPI
      .getIncomeDetailsScreen5({
        region_name: region_name,
        naics_dropdown_value: naics_dropdown_value,
        jobtype_dropdown_value: jobtype_dropdown_value,
        occupation_dropdown_value: occupation_dropdown_value,
      })
      .then((res) => {
        let incomeDataScreen5 = res.data.data;
        dispatch(handleIncomeDataScreen5(incomeDataScreen5));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleIncomeDataScreen5(data) {
  return {
    type: ActionTypesScreen5.GET_INCOME_DATA_SCREEN5,
    payload: data,
  };
}

export function fetchIncomeDiffDataScreen5(
  region_name,
  naics_dropdown_value,
  jobtype_dropdown_value,
  occupation_dropdown_value
) {
  return (dispatch) => {
    filterAPI
      .getIncomeDiffDetailsScreen5({
        region_name: region_name,
        naics_dropdown_value: naics_dropdown_value,
        jobtype_dropdown_value: jobtype_dropdown_value,
        occupation_dropdown_value: occupation_dropdown_value,
      })
      .then((res) => {
        let incomeDiffDataScreen5 = res.data.data;
        dispatch(handleIncomeDiffDataScreen5(incomeDiffDataScreen5));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleIncomeDiffDataScreen5(data) {
  return {
    type: ActionTypesScreen5.GET_INCOME_DIFF_DATA_SCREEN5,
    payload: data,
  };
}

export function fetchAgeDataScreen5(
  region_name,
  naics_dropdown_value,
  jobtype_dropdown_value,
  occupation_dropdown_value
) {
  return (dispatch) => {
    filterAPI
      .getAgeDetailsScreen5({
        region_name: region_name,
        naics_dropdown_value: naics_dropdown_value,
        jobtype_dropdown_value: jobtype_dropdown_value,
        occupation_dropdown_value: occupation_dropdown_value,
      })
      .then((res) => {
        let ageDataScreen5 = res.data.data;
        dispatch(handleAgeDataScreen5(ageDataScreen5));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleAgeDataScreen5(data) {
  return {
    type: ActionTypesScreen5.GET_AGE_DATA_SCREEN5,
    payload: data,
  };
}

export function fetchRaceDataScreen5(
  region_name,
  naics_dropdown_value,
  jobtype_dropdown_value,
  occupation_dropdown_value
) {
  return (dispatch) => {
    filterAPI
      .getRaceDetailsScreen5({
        region_name: region_name,
        naics_dropdown_value: naics_dropdown_value,
        jobtype_dropdown_value: jobtype_dropdown_value,
        occupation_dropdown_value: occupation_dropdown_value,
      })
      .then((res) => {
        let raceDataScreen5 = res.data.data;
        dispatch(handleRaceDataScreen5(raceDataScreen5));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleRaceDataScreen5(data) {
  return {
    type: ActionTypesScreen5.GET_RACE_DATA_SCREEN5,
    payload: data,
  };
}

export function fetchGenderDataScreen5(
  region_name,
  naics_dropdown_value,
  jobtype_dropdown_value,
  occupation_dropdown_value
) {
  return (dispatch) => {
    filterAPI
      .getGenderDetailsScreen5({
        region_name: region_name,
        naics_dropdown_value: naics_dropdown_value,
        jobtype_dropdown_value: jobtype_dropdown_value,
        occupation_dropdown_value: occupation_dropdown_value,
      })
      .then((res) => {
        let genderDataScreen5 = res.data.data;
        dispatch(handleGenderDataScreen5(genderDataScreen5));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleGenderDataScreen5(data) {
  return {
    type: ActionTypesScreen5.GET_GENDER_DATA_SCREEN5,
    payload: data,
  };
}
